import React, { useState } from 'react';
import { api } from '../lib/api';
import { useLanguage } from '../context/LanguageContext';

export default function Support() {
  const { t } = useLanguage();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    if (!form.message.trim()) {
      setStatus({ type: 'error', message: t('support.required') });
      return;
    }
    setSubmitting(true);
    try {
      await api.post('/api/support', {
        name: form.name,
        email: form.email,
        subject: form.subject,
        message: form.message,
      });
      setStatus({ type: 'success', message: t('support.success') });
      setForm({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      console.error('Support form error', err);
      setStatus({ type: 'error', message: t('support.error') });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="card" style={{ maxWidth: 640, margin: '0 auto' }}>
      <h1>{t('support.title')}</h1>
      <p style={{ color: '#666', marginBottom: 24 }}>{t('support.subtitle')}</p>

      {status ? (
        <div
          className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-error'}`}
          style={{ marginBottom: 16 }}
        >
          {status.message}
        </div>
      ) : null}

      <form onSubmit={handleSubmit} className="form-grid">
        <label className="form-field">
          <span>{t('support.name')}</span>
          <input
            name="name"
            type="text"
            value={form.name}
            onChange={handleChange}
            autoComplete="name"
          />
        </label>
        <label className="form-field">
          <span>{t('support.email')}</span>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            autoComplete="email"
          />
        </label>
        <label className="form-field">
          <span>{t('support.subject')}</span>
          <input
            name="subject"
            type="text"
            value={form.subject}
            onChange={handleChange}
            autoComplete="off"
          />
        </label>
        <label className="form-field">
          <span>{t('support.message')}</span>
          <textarea
            name="message"
            rows="5"
            value={form.message}
            onChange={handleChange}
            required
          />
        </label>
        <button className="btn btn-primary" type="submit" disabled={submitting}>
          {submitting ? t('common.loading') : t('actions.send')}
        </button>
      </form>
    </div>
  );
}
